module.exports = __webpack_public_path__ + "static/media/gooieneemlander-min.fe93beb5.png";